function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import RichTextEditor from 'react-rte';
import { actions as ppcActions } from '../../../reducers/ppc.reducer';
import Card from '../../common/card/Card.react';
import CardHeader from '../../common/card/CardHeader.react';
import CardBody from '../../common/card/CardBody.react';
import Button from '../../common/Button.react';
var FullImageComponent = function FullImageComponent(_ref) {
  var componentID = _ref._id,
    pageID = _ref.pageID,
    paragraph = _ref.paragraph;
  var dispatch = useDispatch();
  var _useState = useState(RichTextEditor.createEmptyValue()),
    _useState2 = _slicedToArray(_useState, 2),
    state = _useState2[0],
    setState = _useState2[1];
  useEffect(function () {
    if ((paragraph === null || paragraph === void 0 ? void 0 : paragraph.length) > 0) setState(RichTextEditor.createEmptyValue().setContentFromString(paragraph, 'html'));
  }, [paragraph]);
  return /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(CardHeader, {
    title: "Paragraph Component",
    button: {
      label: 'Delete',
      type: 'delete',
      apiID: 'delete-component',
      requireConfirmation: true,
      onClick: function onClick() {
        dispatch({
          type: ppcActions.pageComponent,
          payload: {
            formData: {
              componentID: componentID,
              pageID: pageID,
              apiID: 'delete-component'
            },
            method: 'delete'
          }
        });
      }
    }
  }), /*#__PURE__*/React.createElement(CardBody, null, /*#__PURE__*/React.createElement(RichTextEditor, {
    value: state,
    className: "a-editor__editor",
    onChange: function onChange(val) {
      setState(val);
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "a__btns"
  }, /*#__PURE__*/React.createElement(Button, {
    label: "Update",
    apiID: "update-paragraph",
    onClick: function onClick() {
      dispatch({
        type: ppcActions.pageComponent,
        payload: {
          formData: {
            paragraph: state.toString('html'),
            componentID: componentID,
            pageID: pageID,
            apiID: 'update-paragraph'
          },
          method: 'put',
          route: 'paragraph'
        }
      });
    },
    style: {
      width: 120
    }
  }))));
};
export default FullImageComponent;